const admin = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/backstage/backstage.vue')
const adminIndex = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/backstageIndex/backstageIndex.vue')
const columnSupervise = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/columnSupervise/columnSupervise.vue')
const hospitalSave = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/columnSupervise/hospitalSave.vue')
const doctorCore = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/columnSupervise/doctorCore.vue')
const pageSave = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/pageSave/pageSave.vue')
const videoAdd = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/videoAdd/videoAdd.vue')
const videoList = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/videoList/videoList.vue')
const videoTypeList = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/videoTypeList/videoTypeList.vue')
const videoClassifyAdd = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/videoClassifyAdd/videoClassifyAdd.vue')
const doctorAdd = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/doctorAdd/doctorAdd.vue')
const doctorSave = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/doctorSave/doctorSave.vue')
const doctorlist = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/doctorlist/doctorlist.vue')
const articleAdd = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/articleAdd/articleAdd.vue')
const artcleActivityAdd = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/artcleActivityAdd/artcleActivityAdd.vue')
const artcleActivitySave = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/artcleActivitySave/artcleActivitySave.vue')
const articleSave = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/articleSave/articleSave.vue')
const articleList = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/articleList/articleList.vue')
const articleRecovery = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/articleRecovery/articleRecovery.vue')
const registerSupervise = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/registerSupervise/registerSupervise.vue')
const wxUserSupervise = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/wxUserSupervise/wxUserSupervise.vue')
const systemParameterSave = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/systemParameterSave/systemParameterSave.vue')
const smsSave = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/smsSave/smsSave.vue')
const helpSave = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/helpSave/helpSave.vue')
const userSupervise = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/userSupervise/userSupervise.vue')
const subscribeTemplateSupervise = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/subscribeTemplateSupervise/subscribeTemplateSupervise.vue')
const subscribeNewsPush = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/subscribeNewsPush/subscribeNewsPush.vue')
const wechatRouter = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/wechatRouter/wechatRouter.vue')
const pushTaskList = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/pushTaskList/pushTaskList.vue')
const pushInclude = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/pushInclude/pushInclude.vue')
const smsTemplate = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/smsTemplate/smsTemplate.vue')
const smsPush = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/smsPush/smsPush.vue')
const wxUserCase = () => import( /* webpackChunkName: "group-foo" */ 'VIEWS/admin/wxUserCase/wxUserCase.vue')


export default [
  {
    path: '/admin',
    name: 'admin',
    component: admin,
    redirect: '/admin/home',
    children: [
      {
        // 后台首页 也是个人中心
        path: 'home',
        name: 'home',
        component: adminIndex
      },
      {
        // 栏目管理
        path: 'columnSupervise',
        name: 'columnSupervise',
        component: columnSupervise
      },
      {
        // 栏目管理-医院简介设置
        path: 'hospitalSave',
        name: 'hospitalSave',
        component: hospitalSave
      },
      {
        // 栏目管理-会诊中心设置
        path: 'doctorCore',
        name: 'doctorCore',
        component: doctorCore
      },
      {
        // 页面设置
        path: 'pageSave/:modular',
        name: 'pageSave',
        component: pageSave
      },
      {
        // 视频添加
        path: 'videoAdd',
        name: 'videoAdd',
        component: videoAdd
      },
      {
        // 视频列表
        path: 'videoList',
        name: 'videoList',
        component: videoList
      },
      {
        // 视频分类列表
        path: 'videoTypeList',
        name: 'videoTypeList',
        component: videoTypeList
      },
      {
        // 视频分类添加
        path: 'videoClassifyAdd',
        name: 'videoClassifyAdd',
        component: videoClassifyAdd
      },
      {
        // 添加专家
        path: 'doctorAdd',
        name: 'doctorAdd',
        component: doctorAdd
      },
      {
        // 修改专家
        path: 'doctorSave/:id',
        name: 'doctorSave',
        component: doctorSave
      },
      {
        // 专家列表
        path: 'doctorlist',
        name: 'doctorlist',
        component: doctorlist
      },
      {
        // 添加活动文章
        path: 'artcleActivityAdd',
        name: 'artcleActivityAdd',
        component: artcleActivityAdd
      },
      {
        // 修改活动文章
        path: 'artcleActivitySave/:id',
        name: 'artcleActivitySave',
        component: artcleActivitySave
      },
      {
        // 添加文章
        path: 'articleAdd',
        name: 'articleAdd',
        component: articleAdd
      },
      {
        // 修改文章
        path: 'articleSave/:id',
        name: 'articleSave',
        component: articleSave
      },
      {
        // 文章列表
        path: 'articleList',
        name: 'articleList',
        component: articleList
      },
      {
        // 回收站
        path: 'articleRecovery',
        name: 'articleRecovery',
        component: articleRecovery
      },
      {
        // 挂号管理
        path: 'registerSupervise',
        name: 'registerSupervise',
        component: registerSupervise
      },
      {
        // 微信用户管理
        path: 'wxUserSupervise',
        name: 'wxUserSupervise',
        component: wxUserSupervise
      },
      {
        // 推送收录
        path: 'pushInclude',
        name: 'pushInclude',
        component: pushInclude
      },
      {
        // 订阅消息模板管理
        path: 'subscribeTemplateSupervise',
        name: 'subscribeTemplateSupervise',
        component: subscribeTemplateSupervise
      },
      {
        // 订阅消息发送界面
        path: 'subscribeNewsPush',
        name: 'subscribeNewsPush',
        component: subscribeNewsPush
      },
      {
        // 订阅消息推送任务列表页
        path: 'pushTaskList',
        name: 'pushTaskList',
        component: pushTaskList
      },
      {
        // 基本参数设置
        path: 'systemParameterSave',
        name: 'systemParameterSave',
        component: systemParameterSave
      },
      {
        // 短信接口设置
        path: 'smsSave',
        name: 'smsSave',
        component: smsSave
      },
      {
        // 帮助信息设置
        path: 'helpSave',
        name: 'helpSave',
        component: helpSave
      },
      {
        // 用户管理
        path: 'userSupervise',
        name: 'userSupervise',
        component: userSupervise
      },
      {
        // 小程序路由管理
        path: 'wechatRouter',
        name: 'wechatRouter',
        component: wechatRouter
      },
      {
        // 短信模板管理
        path: 'smsTemplate',
        name: 'smsTemplate',
        component: smsTemplate
      },
      {
        // 短信推送
        path: 'smsPush',
        name: 'smsPush',
        component: smsPush
      },
      {
        // 病例管理
        path: 'wxUserCase',
        name: 'wxUserCase',
        component: wxUserCase
      },
    ]
  },
]


// WEBPACK FOOTER //
// ./src/router/modules/admin.js